

import { Component, Inject, ViewChild } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Wrapper } from '../../components/wrapper.component';
import { OnInit } from '@angular/core';
import { DialogWrapperComponent } from '../../components/wrappers/dialog-wrapper.component';
import { JoiAccount, LineItemTemplate } from 'globals/store/accounts.data';
import { createId } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';
import { take } from 'rxjs/operators';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';

@Component({
    selector: 'line-items-dialog',
    templateUrl: './line-items.dialog.html',
    styleUrls: ['../../components/wrappers/add-manage-wrapper.scss', './line-items.dialog.scss'],
    standalone: true,
    imports: [DialogWrapperComponent,  CommonModule],
})


export class LineItemsDialogComponent extends Wrapper<LineItemsDialogComponent> implements OnInit {
  account: Partial<JoiAccount>
  maxHeight = '500px'
  showAdd = false
  adderY: number
  adderX: number
  item: LineItemTemplate
  @ViewChild(DialogWrapperComponent) dialogWrapper : DialogWrapperComponent

  constructor(
    public dialogRef:MatDialogRef<LineItemsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LineItemsDialogData,
  ) {
    super()
    this.subProp(this.store.select('accounts', 'account'), 'account')
  }

  ngOnInit() {
    let { x, y } = this.data
    if (y && document.body.clientHeight - y < 400) {
      y = Math.max(1, document.body.clientHeight - 400);
      this.adderY = y
      this.adderX = x + 200
    }
    if (x && y) this.dialogRef.updatePosition({ top: y + 'px', left: x + 'px' });
  }

  async openAddItem(event: MouseEvent) {
  const sortNumber = !this.account?.lineItems?.length ? 1 : Math.max(...this.account.lineItems.map(l => l.sortNumber)) + 1
   this.item = { id: createId(), sortNumber, name: '', unitRate: 0, unitCost: 0 }
   const dialogRef =this.dialog.open(AddLineItemDialogComponent, { data: { x: this.adderX, y: this.adderY, item: this.item } })
   this.item = await lastValueFrom(dialogRef.afterClosed().pipe(take(1)))
   if(this.item.name){
     this.saveItem()
   }
  }

  async saveItem() {
    this.account.lineItems.push(this.item)
    await this.accountService.saveLineItems(this.account)
    this.dialogWrapper.fitChildrenWithDelay(100)
    this.showAdd = false
  }

  close() {
    this.dialogRef.close()
  }
  

}

export interface LineItemsDialogData {
  x: number
  y: number
}

@Component({
    selector: 'add-line-item-dialog',
    template: `
  <div class="adder" (clickOutside)="dialogRef.close()">
   <div class="grid">
    <h5 class="header">SORT<br/>NUMBER</h5>
    <h5 class="header item">ITEM</h5>
    <h5 class="header">UNIT RATE</h5>
    <h5 class="header">UNIT COST</h5>
    <joi-input 
      [(model)]="data.item.sortNumber" 
      [fixedWidth]="true"
      [placeholder]="'...'"
      [allowableCharacters]="'0123456789'"
    ></joi-input>
    <joi-input 
      [(model)]="data.item.name" 
      [placeholder]="'...'"
      [type]="'textarea'" 
      [autoSelect]="false" 
      [returnable]="true"
    ></joi-input>
    <joi-input 
      [(model)]="data.item.unitRate"
      [fixedWidth]="true"
      [placeholder]="'...'"
      [displayValue]="data.item.unitRate ? (data.item.unitRate | prettyNumbers) : null"
      [allowableCharacters]="'0123456789.'"
    ></joi-input>
    <joi-input 
      [(model)]="data.item.unitCost"
      [fixedWidth]="true"
      [placeholder]="'...'"
      [displayValue]="data.item.unitCost ? (data.item.unitCost | prettyNumbers) : null"
      [allowableCharacters]="'0123456789.'"
    ></joi-input>
  </div>
  <action-button [text]="'SAVE ITEM'" (click)="saveItem()"></action-button>
</div>
    `,
    styleUrls: ['../../components/wrappers/add-manage-wrapper.scss', './line-items.dialog.scss'],
    standalone: true,
    imports: [PrettyNumbersPipe, CommonModule, JoiInputComponent, ActionButtonComponent],
})
class AddLineItemDialogComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<LineItemsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LineItemsDialogData & { item: any }
  ) {}

  ngOnInit() {
    const { x, y } = this.data;
    if (x && y) this.dialogRef.updatePosition({ top: y + 'px', left: x + 'px' });
  }
  saveItem() {
    this.dialogRef.close(this.data.item)
  }
}
